<template>
  <div>
    <br />
    <button
      type="button"
      class="btn btn-outline-primary btn-created"   @click="showModal()">Cadastrar servico</button>
    <b-modal ref="my-modal" hide-footer title="Servico">
      <div class="d-block">
        <form @submit="checkForm">
          <div class="row">
            <div class="col-md-12">
             
            <div class="col-md-12">
              <div class="form-group">
                <label for="name">Nome</label>
                <input type="text" class="form-control" v-model="payload.nomeServico" />
              </div>
            </div> 
          </div>
          </div>
          <div class="text-right">
            <button type="submit" class="btn btn-outline-primary">Salvar</button>
          </div>
        </form>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { AdminService } from "@/http";
import { Servico } from "@/soganhei";

export default {
  name: "Servico",
  components: {},
  data: () => {
    return {
      payload: Servico,
      itemsServicos: [],
      buscarServicos: ""
    };
  },
  methods: {
    showModal: function() {
      
      this.payload = {}
      this.$refs["my-modal"].show();
    },
    visualizarServico(idServico) {
      
      AdminService.ServicoByid(idServico)
        .then(response => {
          this.payload = response.data;
          this.$refs["my-modal"].show();
        })
        .catch(error => {
          window.console.log(error);
        });
    },
    servicos(item) {
      this.payload.idServico = item.idServico;
    },
    checkForm(e) {
      e.preventDefault();

      const payload = Object.assign({}, this.payload);
       
       
      AdminService.SalvarServico(payload)
        .then(respose => {
         
         window.console.warn(respose.statusText);
          this.$notify({
            group: "notify",
            text: "Salvo com sucessso",
            type: "success"
          });

           this.payload = {};

          this.$refs["my-modal"].hide();
          this.$emit("servicos");

        })
        .catch(error => {
          window.console.log(error);
        });
    }
  }
};
</script>